/**
 * Resolves and stamps the color mode on <html> before first paint, so
 * there is no flash of the wrong theme. Must load synchronously in
 * <head>, ahead of sb-tailwind.css and any other stylesheet.
 *
 * Precedence: explicit user choice (localStorage) > OS preference
 * (prefers-color-scheme) > dark (brand default when the OS reports no
 * preference or the browser doesn't support the media query).
 */
(function () {
  var STORAGE_KEY = 'sb-theme';
  var root = document.documentElement;
  var stored = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    /* localStorage can throw in locked-down/private contexts — fall through */
  }

  var mode = stored;
  if (mode !== 'light' && mode !== 'dark') {
    var prefersLight =
      window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
    mode = prefersLight ? 'light' : 'dark';
  }

  root.setAttribute('data-sb-theme', mode);
})();
